import { SET_CALL, SET_CALL_ACTIVE, DROP_CALL } from '../constants';

/***
 * store for calls from socket
 * 
  {
    id: '1739780077.905351',
    source: '100',
    source_inner_id: 'lane-AZ-1',
    status: 'wait'
  },
    
 * 
 */

const test = false;

const initialState = test
  ? {
      'payment-1': {
        source: '100',
        source_inner_id: 'payment-1',
        id: 'payment-1',
        status: 'wait',
      },
    }
  : {};

export default (state, action) => {
  const defaultState = {
    calls: initialState,
  };
  if (!state) {
    state = defaultState;
  }
  let out = { ...state.calls };
  let data = action?.data;
  let node;

  switch (action.type) {
    // set call
    case SET_CALL:
      out[data.source_inner_id] = { status: 'wait', ...data };
      return {
        calls: out,
      };

    // set call active
    // data - source_inner_id
    case SET_CALL_ACTIVE:
      let call = out[data];
      if (!call) {
        node = window.config.nodes[data];
        call = {
          id: data.id,
          source: node.phone,
          source_inner_id: data,
        };
      }
      call.status = 'active';
      out[data] = call;
      return {
        calls: out,
      };

    // drop call
    case DROP_CALL:
      delete out[data];
      window.removeActiveCall(data);
      return {
        ...state,
        calls: out,
      };

    // def
    default:
      return state;
  }
};
